// Vendor Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash';

// Components
import Button from '../core/button';
import Loading from '../core/loading';
import Permissions from '../core/permissions';

// Redux Actions
import { formSubmitFetch, registerForm, resetForm, setFieldValue } from '../../actions/form-data-actions';
import { globalResponseAdd } from '../../actions/global-response-actions';

class MediaItemRepublish extends Component {
  componentDidMount() {
    const { formName = 'mediaItemRepublish', registerForm } = this.props;
    registerForm(formName);
  }

  componentWillReceiveProps(nextProps) {
    const {fetched, guid} = this.props;
    const {
      error,
      fetched: nextFetched,
      globalResponseAdd,
      resetForm,
      response,
      responseAction = 'republished', // default provided here
    } = nextProps;

    if (guid) {
      if (!fetched && nextFetched) {
        const globalResponse = error
          ? {error}
          : {
            success: `Record, ${guid}, has been successfully ${responseAction} to the state ${get(
              response,
              '0.statusPhrase'
            )}`,
          };

        globalResponseAdd(globalResponse);
        resetForm(nextProps.formName, false, true);
      }
    }
  }

  handleButtonClick = () => {
    const { formName = 'mediaItemRepublish', formSubmitFetch, guid, setFieldValue } = this.props;
    if (guid) {
      setFieldValue(formName, 'targets', [guid]).then(() => {
        formSubmitFetch(formName);
      });
    }
  };

  renderButton() {
      const { fetching, guid, label = 'Republish Media Item' } = this.props;
      return !fetching ? (
        <Permissions
            accessRequirement="write"
            lockAccess={true}
            recordId={guid}
            requiresServiceAccess={true}
            serviceKey="mediaItems"
        >
          <Button onClick={this.handleButtonClick}>{label}</Button>
        </Permissions>
      ) : null;
  }

    render() {
        const { className: classNameProp, fetching, guid } = this.props;
        const className = classnames('mediaitem-republish', classNameProp);
        return guid ? (
            <div className={className}>
                <Loading loading={fetching} small={true} />
                {this.renderButton()}
            </div>
        ) : null;
    }
}

MediaItemRepublish.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    formName: PropTypes.string,
    formSubmitFetch: PropTypes.func.isRequired,
    globalResponseAdd: PropTypes.func.isRequired,
    guid: PropTypes.string,
    label: PropTypes.string,
    registerForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    response: PropTypes.array,
    responseAction: PropTypes.string,
    setFieldValue: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => get(state, ['formData', props.formName], {});

const mapDispatchToProps = { formSubmitFetch, globalResponseAdd, registerForm, resetForm, setFieldValue };

export default connect(mapStateToProps, mapDispatchToProps)(MediaItemRepublish);
